import { Channel } from 'types/channels';
import CustomModal from 'components/DesignSystems/New/CustomModal';

interface CheckboxFormGroupProps {
  id: string;
  label: string;
  isChecked: boolean;
  isDisabled?: boolean;
  onChange: (checked: boolean) => void;
}

const CheckboxFormGroup = ({
  id,
  label,
  isChecked,
  isDisabled,
  onChange,
}: CheckboxFormGroupProps) => (
  <div className="mb-3">
    <div className="form-check">
      <input
        type="checkbox"
        className="form-check-input"
        checked={isChecked}
        onChange={(e) => onChange(e.target.checked)}
        id={id}
        disabled={isDisabled}
      />
      <label className="form-check-label" htmlFor={id}>
        {label}
      </label>
    </div>
  </div>
);

interface ChannelFormModalProps {
  show: boolean;
  channel: Channel;
  isEditing: boolean;
  onClose: () => void;
  onSave: () => void;
  onChange: (channel: Channel) => void;
  error: string | null;
}
export function ChannelFormModal({
  show,
  channel,
  isEditing,
  onClose,
  onSave,
  onChange,
  error,
}: ChannelFormModalProps) {
  const isPrivate = channel.membershipType === 'private';
  return (
    <CustomModal
      show={show}
      heading={isEditing ? 'Edit Channel' : 'Add New Channel'}
      onClose={onClose}
      onConfirm={onSave}
      saveButton={isEditing ? 'Save' : 'Add'}
      buttonDisable={!channel.displayName}
    >
      <div className="mb-3">
        <label className="form-label">Channel Name *</label>
        <input
          type="text"
          className={`form-control ${error ? 'is-invalid' : ''}`}
          value={channel.displayName}
          onChange={(e) =>
            onChange({ ...channel, displayName: e.target.value })
          }
          placeholder="Enter channel name"
        />
        {error && <div className="invalid-feedback">{error}</div>}
      </div>
      <div className="mb-3">
        <label className="form-label">Description</label>
        <textarea
          className="form-control"
          value={channel.description}
          onChange={(e) =>
            onChange({ ...channel, description: e.target.value })
          }
          placeholder="What is this channel about?"
        />
      </div>
      <CheckboxFormGroup
        id="isPrivate"
        label="Is this Channel Private?"
        isChecked={isPrivate}
        onChange={(checked) =>
          onChange({
            ...channel,
            membershipType: checked ? 'private' : 'standard',
            isFavoriteByDefault: checked ? false : channel.isFavoriteByDefault,
          })
        }
      />
      <CheckboxFormGroup
        id="isFavorite"
        label="Display by Default?"
        isChecked={channel.isFavoriteByDefault && !isPrivate}
        isDisabled={isPrivate}
        onChange={(checked) =>
          onChange({
            ...channel,
            isFavoriteByDefault: checked,
          })
        }
      />
    </CustomModal>
  );
}
